var _excluded = ["hierarchy", "onClick", "disabled"],
    _excluded2 = ["hierarchy", "onClick", "disabled"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { FloraButton, forwardRef, styled } from '@grupoboticario/flora-react';
import { ChevronLeftIcon, ChevronRightIcon } from '@grupoboticario/flora-react-icons';
import React, { useCallback, useContext, useMemo } from 'react';
import { CarouselContext } from '../Carousel';
var CustomText = styled('span', {
  display: 'inline-block',
  opacity: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '0%'
});

CustomText.toString = () => "." + CustomText.className;

export var CustomButtom = styled(props => /*#__PURE__*/React.createElement(FloraButton, props), {
  display: 'inline-flex !important',
  height: '$6 !important',
  position: 'absolute',
  paddingBottom: '0 !important',
  paddingTop: '0 !important',
  transition: 'width 300ms ease-out',
  width: '$6 !important',
  zIndex: '$overlay',
  padding: '0 !important',
  top: '50%',
  '@mobile': {
    width: '$10 !important',
    height: '$10 !important',
    padding: '$4 !important',
    '&:hover': {
      width: '108px !important',
      ["" + CustomText.toString()]: {
        opacity: 1,
        transition: 'width 300ms ease-out, opacity 300ms ease-in',
        width: '100%'
      }
    }
  },
  '&::before': {
    content: '',
    height: '100%',
    left: ' 50%',
    minHeight: '$11',
    minWidth: '$11',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    top: '50%',
    width: '100%'
  }
});

CustomButtom.toString = () => "." + CustomButtom.className;

export var NextButton = forwardRef((_ref, forwardedRef) => {
  var {
    hierarchy = 'secondary',
    onClick,
    disabled
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var {
    state: {
      goToNext,
      onNextPress,
      currentIndex,
      pages,
      infinite
    }
  } = useContext(CarouselContext);
  var handleOnClick = useCallback(event => {
    goToNext();
    onNextPress();
    onClick == null ? void 0 : onClick(event);
  }, [goToNext, onClick, onNextPress]);
  var isLastPage = useMemo(() => {
    return !!disabled || !infinite && currentIndex + 1 === pages;
  }, [currentIndex, pages, infinite, disabled]);
  return /*#__PURE__*/React.createElement(CustomButtom, _extends({}, props, {
    hierarchy: hierarchy,
    onClick: handleOnClick,
    disabled: isLastPage,
    ref: forwardedRef,
    "data-to": "next"
  }), /*#__PURE__*/React.createElement(CustomText, null, "pr\xF3ximo"), /*#__PURE__*/React.createElement(ChevronRightIcon, null));
});
export var PreviousButton = forwardRef((_ref2, forwardedRef) => {
  var {
    hierarchy = 'secondary',
    onClick,
    disabled
  } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var {
    state: {
      goToPrevious,
      onPreviousPress,
      currentIndex,
      infinite
    }
  } = useContext(CarouselContext);
  var isFirstPage = useMemo(() => {
    return !!disabled || !infinite && !currentIndex;
  }, [currentIndex, infinite, disabled]);
  var handleOnClick = useCallback(event => {
    goToPrevious();
    onPreviousPress();

    if (onClick) {
      onClick(event);
    }
  }, [goToPrevious, onClick, onPreviousPress]);
  return /*#__PURE__*/React.createElement(CustomButtom, _extends({}, props, {
    hierarchy: hierarchy,
    onClick: handleOnClick,
    disabled: isFirstPage,
    ref: forwardedRef,
    "data-to": "previous"
  }), /*#__PURE__*/React.createElement(ChevronLeftIcon, null), /*#__PURE__*/React.createElement(CustomText, null, "anterior"));
});
//# sourceMappingURL=NavigationButton.js.map